import { render, staticRenderFns } from "./motorcycles.vue?vue&type=template&id=53b403bf"
import script from "./motorcycles.vue?vue&type=script&lang=js"
export * from "./motorcycles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports